import { addVendor } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useMutation } from "react-query";
import { toast } from "../../../../components/toastNotification";
import { addStateVendor } from "../atoms/atoms";
import { useRecoilState } from "recoil";

const useAddVendor = () => {
  const [actionAddState, setActionAddState] = useRecoilState(addStateVendor);
  const { mutate } = useMutation((VendorNewData) => addVendor(VendorNewData), {
    onSuccess: (res) => {
      toast.fire("Success", "Vendor added successfully.", "success");
      setActionAddState(!actionAddState);
    },
    onError: (error) => {
      toast.fire("Failed", "Failed to add vendor.", "error");
    },
  });
  return mutate;
};
export default useAddVendor;
